import { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';

// Sidebar layout.
//
// U-ADM-09 · pre-launch audit hardening. At <=900px the pre-audit
// stylesheet flipped the sidebar to `position: static`, so every
// route rendered as 300px of nav then content — staff on their
// phones scrolled past the whole menu every navigation. Add a
// hamburger button (visible only on small screens via CSS) that
// toggles the drawer. On route change the drawer closes so the
// admin doesn't have to close it manually after picking a page.
export default function Layout() {
  const { session, permissions, signOut } = useAuth();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setDrawerOpen(false);
  }, [location.pathname]);

  return (
    <div className={`app ${drawerOpen ? 'drawer-open' : ''}`}>
      <button
        type="button"
        className="hamburger"
        onClick={() => setDrawerOpen((v) => !v)}
        aria-label={drawerOpen ? 'إغلاق القائمة' : 'فتح القائمة'}
        aria-expanded={drawerOpen}
      >
        <span aria-hidden="true">☰</span>
      </button>
      {drawerOpen && (
        <button
          type="button"
          className="drawer-backdrop"
          aria-label="إغلاق القائمة"
          onClick={() => setDrawerOpen(false)}
        />
      )}
      <aside className="sidebar">
        <div className="sidebar-brand">
          <img src={`${import.meta.env.BASE_URL}brand/mersal-logo.png`} alt="Mersal" />
          <div className="brand-text">
            <strong>مرسال</strong>
            <small>لوحة التحكم</small>
          </div>
        </div>

        {permissions.canHome && (
          <NavLink to="/home" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            الرئيسية
          </NavLink>
        )}

        {permissions.canDonations && (
          <NavLink to="/donations" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            التبرعات
          </NavLink>
        )}

        {permissions.canPaymentMethods && (
          <NavLink to="/payment-methods" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            طرق التبرع
          </NavLink>
        )}

        {permissions.canCommunity && (
          <NavLink to="/community" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            مجتمع مرسال
          </NavLink>
        )}

        {permissions.canChat && (
          <NavLink to="/chat" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            الدردشة
          </NavLink>
        )}

        {(permissions.canVolunteering || permissions.canViewVolunteering) && (
          <NavLink to="/volunteering" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            التطوع
          </NavLink>
        )}

        {permissions.is_super_admin && (
          <NavLink to="/team" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            إدارة المستخدمين
          </NavLink>
        )}

        {/* Every logged-in admin can enrol a TOTP factor on their own
            account — no permission required. Sits at the bottom of the
            nav next to the sign-out button. */}
        <NavLink to="/security" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
          الأمان
        </NavLink>

        <div className="sidebar-footer">
          <div>{session?.user.email}</div>
          {permissions.is_super_admin && (
            <div style={{ fontSize: 11, marginTop: 4, opacity: 0.85 }}>
              Super Admin — صلاحيات كاملة
            </div>
          )}
          <button type="button" onClick={signOut}>
            تسجيل الخروج
          </button>
        </div>
      </aside>

      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
